import {FactoryID} from "./type-interface/ModelFactoryType";
import BrowseRouteFactory from "../route/BrowseRouteFactory";
import BasicModelFactory from "./basic/BasicModelFactory";
import ModelFactoryService from "./basic/ModelFactoryService";
import AccountRouteFactory from "../route/subject/AccountRouteFactory";
import OrganisationUserDataFactory from "../data/subject/OrganisationUserDataFactory";
import EndRouteFactory from "../route/simple/EndRouteFactory";
import LocatePageListDataFactory from "../data/locate/LocatePageListDataFactory";
import LocatePageListRouteFactory from "../route/locate/LocatePageListRouteFactory";
import LocateDataFactory from "../data/locate/LocateDataFactory";
import LocateCountryDataFactory from "../data/locate/LocateCountryDataFactory";
import LocateRouteFactory from "../route/locate/LocateRouteFactory";
import MessageDataFactory from "../data/subject/message/MessageDataFactory";
import MessagePageListDataFactory from "../data/subject/message/MessagePageListDataFactory";
import MessageRouteFactory from "../route/subject/message/MessageRouteFactory";
import MessagePageListRouteFactory from "../route/subject/message/MessagePageListRouteFactory";
import MessageListRouteFactory from "../route/subject/message/MessageListRouteFactory";
import {PostStatus, PostType} from "../manager/post/PostManager";
import PostRouteFactory from "../route/subject/PostRouteFactory";
import PostListRouteFactory from "../route/subject/PostListRouteFactory";
import RouteChoice from "./basic/route/RouteChoice";
import MyProfileRouteFactory from "../route/subject/MyProfileRouteFactory";
import PostDataFactory from "../data/subject/PostDataFactory";
import PageDataFactory from "../data/subject/PageDataDactory";
import PostActivityDataFactory from "../data/subject/PostActivityDataFactory";
import PostEntryRouteFactory from "../route/subject/PostEntryRouteFactory";
import PostStatusRouteFactory from "../route/subject/PostStatusRouteFactory";
import SubPageRouteFactory from "../route/SubPageRouteFactory";

export interface IBasicModelFactories
{
    [key: string]: BasicModelFactory;
}

export interface IModelFactory extends IBasicModelFactories
{
    browseRoute: BrowseRouteFactory;
    accountRoute: AccountRouteFactory;

    myProfileRoute: MyProfileRouteFactory;
    postRoute: PostRouteFactory;
    postListRoute: PostListRouteFactory;
    postEntryRoute: PostEntryRouteFactory;
    postStatusRoute: PostStatusRouteFactory;

    locateRoute: LocateRouteFactory;
    locatePageListRoute: LocatePageListRouteFactory;
    messageRoute: MessageRouteFactory;
    messagePageListRoute: MessagePageListRouteFactory;
    messageListRoute: MessageListRouteFactory;
    subPageRoute: SubPageRouteFactory;

    endRoute: EndRouteFactory;

    postData: PostDataFactory;
    pageData: PageDataFactory;
    postActivityData: PostActivityDataFactory;

    locateData: LocateDataFactory;
    locatePageListData: LocatePageListDataFactory;
    locateCountryData: LocateCountryDataFactory;
    messageData: MessageDataFactory;
    messagePageListData: MessagePageListDataFactory;
    organisationUserData: OrganisationUserDataFactory;
}

class ModelFactory
{

    browseRoute: BrowseRouteFactory;
    accountRoute: AccountRouteFactory;

    myProfileRoute: MyProfileRouteFactory;
    postRoute: PostRouteFactory;
    postListRoute: PostListRouteFactory;
    postEntryRoute: PostEntryRouteFactory;
    postStatusRoute: PostStatusRouteFactory;

    locateRoute: LocateRouteFactory;
    locatePageListRoute: LocatePageListRouteFactory;

    messageRoute: MessageRouteFactory;
    messagePageListRoute: MessagePageListRouteFactory;
    messageListRoute: MessageListRouteFactory;
    subPageRoute: SubPageRouteFactory;

    endRoute: EndRouteFactory;

    postData: PostDataFactory;
    pageData: PageDataFactory;
    postActivityData: PostActivityDataFactory;

    locateData: LocateDataFactory;
    locatePageListData: LocatePageListDataFactory;
    locateCountryData: LocateCountryDataFactory;
    messageData: MessageDataFactory;
    messagePageListData: MessagePageListDataFactory;
    organisationUserData: OrganisationUserDataFactory;

    basicModelFactories: IBasicModelFactories = {};

    constructor(props:IModelFactory)
    {

        this.browseRoute = props.browseRoute;
        this.accountRoute = props.accountRoute;

        this.myProfileRoute = props.myProfileRoute;
        this.postRoute = props.postRoute;
        this.postListRoute = props.postListRoute;
        this.postEntryRoute = props.postEntryRoute;
        this.postStatusRoute = props.postStatusRoute;

        this.locateRoute = props.locateRoute;
        this.locatePageListRoute = props.locatePageListRoute;

        this.messageRoute = props.messageRoute;
        this.messagePageListRoute = props.messagePageListRoute;
        this.messageListRoute = props.messageListRoute;
        this.subPageRoute = props.subPageRoute;

        this.endRoute = props.endRoute;

        this.postData = props.postData;
        this.pageData = props.pageData;
        this.postActivityData = props.postActivityData;

        this.locateData = props.locateData;
        this.locatePageListData = props.locatePageListData;
        this.locateCountryData = props.locateCountryData;
        this.messageData = props.messageData;
        this.messagePageListData = props.messagePageListData;
        this.organisationUserData = props.organisationUserData;

        const basicModelFactories: IBasicModelFactories = {};
        for(let key in props){
            let value:any = props[key];
            basicModelFactories[value.id] = value as BasicModelFactory;
        }
        this.basicModelFactories = basicModelFactories;
    }

    getEntryRouteChoice(postType: PostType|null, postID:number, myEdit:boolean = false, postStatus:PostStatus|null = null):RouteChoice | null
    {

        postType = postType ?? "organisation";
        if((postType === "organisation") && myEdit){
            const routeModel = this.accountRoute.getDefaultModel()
            return routeModel?.choices.edit_organisation_profile ?? null;
        }
        const listRouteModel = this.postListRoute.getDefaultModel(postType, myEdit, postStatus);
        if(!listRouteModel){
            return null;
        }
        const choice =  listRouteModel?.choices[postID] ?? null;
        if(choice || ((postStatus !== "expired") && (postStatus !== "draft") && (postStatus !== "pending"))){
            return choice;
        }
        return listRouteModel.requireChoice(postID.toString());
    }

    requireInitialModels():void
    {
        this.pageData.getPageDataModel()
    }

    resetFactories(): void
    {
        for(let key in this.basicModelFactories){
            this.basicModelFactories[key].reset()
        }
    }

    getFactory(factoryID:FactoryID): BasicModelFactory | null
    {
        return this.basicModelFactories[factoryID] ?? null;
    }

    getService(factoryID:FactoryID): ModelFactoryService | null
    {
        const factory: BasicModelFactory | null = this.getFactory(factoryID)
        return factory?.service ?? null
    }

}

let modelFactory: ModelFactory|null = null;

export const createModelFactory = (props: IModelFactory): ModelFactory =>
{
    modelFactory = new ModelFactory(props);
    return modelFactory
}

export const getModelFactory = (): ModelFactory =>
{
    return modelFactory!;
}
